import type { IFormRenderer } from "./IFormRenderer";
import { DefaultFormRenderer } from "./DefaultFormRenderer";
import { CompactFormRenderer } from "./CompactFormRenderer";
import { BareFormRenderer } from "./BareFormRenderer";

type RendererFactory = () => IFormRenderer;

export class RendererRegistry {

    private static readonly _map: Map<string, RendererFactory> = (() => {
        const m = new Map<string, RendererFactory>();
        m.set("default", () => new DefaultFormRenderer());
        m.set("compact", () => new CompactFormRenderer());
        m.set("bare",    () => new BareFormRenderer());
        return m;
    })();

    public static create(name: string): IFormRenderer {
        const factory = RendererRegistry._map.get(name);
        return factory ? factory() : new DefaultFormRenderer();
    }

    public static register(name: string, factory: RendererFactory): void {
        RendererRegistry._map.set(name, factory);
    }
}
